import { FunctionComponent } from 'react'
import { Spinner, Table } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import PersonCell from 'components/ui/personCell'
import { HospitalDoctor } from '../types'
import { formatPhoneNumber } from '../../../utilities/phoneNumber.util'

type DoctorsTableProps = {
  doctors: HospitalDoctor[]
  onEdit: (doctorId: number) => void
  onSendPassword: (doctorId: number) => void
  onRevokeAccess: (doctorId: number) => void
  sendingPasswordDoctorId?: number
  revokingAccessDoctorId?: number
}

const DoctorsTable: FunctionComponent<DoctorsTableProps> = ({
  doctors,
  onEdit,
  onSendPassword,
  onRevokeAccess,
  sendingPasswordDoctorId,
  revokingAccessDoctorId,
}) => (
  <div className="table-wrap">
    <Table hover>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Telefone</th>
          <th className="actions-col">
            <span className="visually-hidden">Ações</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {doctors.map((doctor, index) => {
          const sendingPassword = sendingPasswordDoctorId === doctor.id
          const revokingAccess = revokingAccessDoctorId === doctor.id

          return (
            <tr key={index}>
              <td>
                <PersonCell name={doctor.name} />
              </td>
              <td className="muted">{doctor.email}</td>
              <td className="muted">{formatPhoneNumber(doctor.phoneNumber)}</td>
              <td className="actions-col">
                <div className="row-actions">
                  <button
                    type="button"
                    className="row-action"
                    onClick={() => onEdit(doctor.id)}
                  >
                    <Icon name="edit" size={14} /> Editar
                  </button>
                  <button
                    type="button"
                    className="row-action"
                    disabled={sendingPassword}
                    onClick={() => onSendPassword(doctor.id)}
                  >
                    {sendingPassword ? (
                      <>
                        <Spinner animation="border" size="sm" /> Enviando...
                      </>
                    ) : (
                      <>
                        <Icon name="key" size={14} /> Enviar senha
                      </>
                    )}
                  </button>
                  <button
                    type="button"
                    className="row-action is-danger"
                    onClick={() => onRevokeAccess(doctor.id)}
                  >
                    {revokingAccess ? (
                      <>
                        <Spinner animation="border" size="sm" /> Revogando...
                      </>
                    ) : (
                      <>
                        <Icon name="ban" size={14} /> Revogar
                        acesso
                      </>
                    )}
                  </button>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  </div>
)

export default DoctorsTable
